module.exports = __webpack_public_path__ + "img/server_group.b902df8b.png";